import { render } from "./VideoUploadPopUpComponent2.vue?vue&type=template&id=12129b42&scoped=true"
import script from "./VideoUploadPopUpComponent2.vue?vue&type=script&lang=js"
export * from "./VideoUploadPopUpComponent2.vue?vue&type=script&lang=js"

import "./VideoUploadPopUpComponent2.vue?vue&type=style&index=0&id=12129b42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12129b42"

export default script